import React from 'react';
import { Mic, MicOff, Video, VideoOff, User, Loader2, ArrowRight } from 'lucide-react';
import AudioEqualizerBars from './AudioEqualizerBars';

// Pantalla de pre-ingreso a una sesión pública de terminal: preview de cámara/mic, nombre.
// Presentacional — toda la lógica vive en useTerminalSession. Extraído de PublicSessionView
// (integración main→dev, epic B1).
const SessionLobby = ({
    space,
    terminalId,
    localStream,
    micEnabled,
    camEnabled,
    participantName,
    setParticipantName,
    joiningSession,
    lobbyVideoRef,
    onToggleMic,
    onToggleCam,
    onJoin,
}) => (
    <div className="psv-lobby-container">
        <div className="psv-lobby-card">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="psv-brand">
                    <span style={{ color: '#3b82f6', fontSize: '20px' }}>●</span>
                    <span>Colonny Terminal</span>
                    <span className="psv-badge psv-badge-terminal">{terminalId}</span>
                </div>
                <span className="psv-badge psv-badge-space">{space}</span>
            </div>

            <div className="psv-lobby-preview">
                {camEnabled && localStream ? (
                    <video ref={lobbyVideoRef} autoPlay playsInline muted className="psv-lobby-video" />
                ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#64748b', gap: '8px' }}>
                        <VideoOff size={36} />
                        <span style={{ fontSize: '12px' }}>Cámara apagada</span>
                    </div>
                )}

                <div className="psv-lobby-controls">
                    <button
                        type="button"
                        onClick={onToggleMic}
                        className={`psv-lobby-btn ${!micEnabled ? 'off' : ''}`}
                        title={micEnabled ? 'Silenciar micrófono' : 'Activar micrófono'}
                    >
                        {micEnabled ? <Mic size={18} /> : <MicOff size={18} />}
                    </button>
                    <button
                        type="button"
                        onClick={onToggleCam}
                        className={`psv-lobby-btn ${!camEnabled ? 'off' : ''}`}
                        title={camEnabled ? 'Apagar cámara' : 'Encender cámara'}
                    >
                        {camEnabled ? <Video size={18} /> : <VideoOff size={18} />}
                    </button>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <span style={{ fontSize: '11px', color: '#94a3b8' }}>Nivel de audio:</span>
                <AudioEqualizerBars stream={localStream} isMuted={!micEnabled} color="#22c55e" numBars={9} />
            </div>

            <form onSubmit={onJoin} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div className="psv-lobby-input-group">
                    <label className="psv-lobby-label">
                        <User size={14} />
                        <span>¿Cómo te llamas? (Tu nombre para la sesión)</span>
                    </label>
                    <input
                        type="text"
                        className="psv-lobby-input"
                        placeholder="Escribe tu nombre o apodo..."
                        value={participantName}
                        onChange={(e) => setParticipantName(e.target.value)}
                        autoFocus
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="psv-lobby-join-btn"
                    disabled={!participantName.trim() || joiningSession}
                >
                    {joiningSession ? (
                        <>
                            <Loader2 size={18} className="psv-spinner" />
                            <span>Conectando a Mediasoup...</span>
                        </>
                    ) : (
                        <>
                            <span>Unirte a la sesión</span>
                            <ArrowRight size={18} />
                        </>
                    )}
                </button>
            </form>

            <div style={{ fontSize: '11px', color: '#64748b', textAlign: 'center' }}>
                Sesión pública temporal vinculada al calendario. Caduca automáticamente al finalizar el evento.
            </div>
        </div>
    </div>
);

export default SessionLobby;
